import React, { useRef, useState } from 'react'
import loader from '../../../../assets/img/loader.svg'
import { useHistory, useLocation } from 'react-router-dom'
import UpcomingReservations from '../../../modals/UpcomingReservations'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { createDragDropManager } from 'dnd-core'
import TableRow from './TableRow'
import { fromInfo, trans } from '../../../../_providers/Translation'
import { useAuthDataContext } from '../../../../_providers/Auth'
import Help from '../../../partials/Help'
import EmployeeInfoPopup from './EmployeeInfoPopup'

// images
import workerImage from '@/assets/img/schedule/icons/worker.svg'
import aboutImage from '@/assets/img/schedule/icons/about.svg'
import mapImage from '@/assets/img/schedule/icons/map.svg'
import { Tooltip } from '@mui/material'

export const manager = createDragDropManager(HTML5Backend)

function Table(props) {
    const auth = useAuthDataContext()
    const history = useHistory()
    const location = useLocation()

    const [popupEmployee, setPopupEmployee] = useState(null)
    const [popupPos, setPopupPos] = useState({ top: 0, left: 0, height: 0 })
    const [popupVisible, setPopupVisible] = useState(false)

    const handleShowEmployeeInfo = (employee, ev) => {
        const rect = ev.currentTarget.getBoundingClientRect()
        setPopupPos({ top: rect.top + window.scrollY, left: rect.left + window.scrollX, height: rect.height })
        setPopupEmployee(employee)
        setPopupVisible(true)
    }

    const handleCloseEmployeeInfo = () => {
        setPopupVisible(false)
        setPopupEmployee(null)
    }

    const searchParams = new URLSearchParams(location.search)
    const upcomingReservationsRef = useRef(null)

    const getReservations = (employeeId, time, periodId) => {

        let reservations = props.data.reservations.filter(r => {
            let match = Number(r.employee_id) === Number(employeeId) &&
                String(r.visit_date_timestamp) === String(time) &&
                Number(r.visit_period_id) === Number(periodId)

            return match
        })

        return reservations
    }

    const handleAddReservation = (employeeId, time, periodId) => {
        let date = new Date(Number(time + '000'))

        let year = date.getFullYear()
        let month = (date.getMonth() + 1).toString().padStart(2, 0)
        let day = date.getDate().toString().padStart(2, 0)
        let fulldate = [year, month, day].join('-')

        let url = '/schedule/reservations/address/add'
            + '?employee_id=' + employeeId
            + '&date=' + fulldate
            + '&visit_period_id=' + periodId
            + '&redirect=schedule'

        history.push(url)
    }


    const handleShowReservations = (id, date) => {
        upcomingReservationsRef.current.open(id, date)
    }

    const tableStyle = {
        tableLayout: 'fixed',
        width: '100%'
    }

    const moveCard = (dragIndex, hoverIndex, reservations) => {
        let dragCard = reservations[dragIndex]
        let hoverCard = reservations[hoverIndex]

        props.moveCard(dragCard, hoverCard)
    }

    const renderCard = (data, index, employeeId, time, periodId) => {
        let reservations = getReservations(employeeId, time, periodId)

        return (
            <TableRow
                key={data.id}
                index={index}
                id={data.id}
                data={data}
                state={reservations}
                moveCard={(dragIndex, hoverIndex) => moveCard(dragIndex, hoverIndex, reservations)}
                changePriority={props.changePriority}
            />
        )
    }

    const hasFreeDay = (employee, date) => {
        // console.log(employee);
        // console.log(date)
        return Boolean(employee.freedays.find(day => day.date === date))
    }

    return (
        <>

            {props.loading
                ?
                <img src={loader} alt="loading" />
                :
                (Array.isArray(props.data?.employees) ? props.data.employees : []).map(e =>
                    <React.Fragment key={'emp-' + e.id}>
                        <div style={{ position: 'relative' }}>
                            <div className="table-scroller">
                                <table className="schedule" style={tableStyle}>
                                    <colgroup>
                                        <col style={{ width: '150px' }} />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                        <col />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th className="head" colSpan="8">
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <img src={workerImage} />
                                                        <span>{e.name} {e.lastname}</span>
                                                    </div>

                                                    {/* //NEW: Нов бутон за информация за служител*/}
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="button button-default"
                                                            onClick={ev => { ev.stopPropagation(); handleShowEmployeeInfo(e, ev) }}
                                                            title={trans('buttons.employeeInfo') || 'Info'}
                                                        >
                                                            <img src={aboutImage} />
                                                            {trans('labels.aboutEmployee')}
                                                        </button>
                                                    </div>

                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style={{ borderRight: '1px solid #E5E5EF' }}>
                                                <span
                                                    style={{
                                                        alignItems: "flex-start",
                                                        paddingLeft: '20px',
                                                    }}
                                                >
                                                    {trans('tables.visitTime')}
                                                </span>
                                            </th>
                                            {Object.values(props.data.dates).map(d =>
                                                <th key={'thd-' + d.date} style={{ backgroundColor: hasFreeDay(e, d.date_ymd) ? '#ffdd7e' : '' }}>
                                                    {hasFreeDay(e, d.date_ymd)
                                                        ?
                                                        <span>
                                                            <b>
                                                                {d.date}
                                                            </b>
                                                            {`${d.day} (${trans('labels.freeDay')})`}
                                                        </span>
                                                        :

                                                        <a
                                                            className="show-map"
                                                            onClick={() => handleShowReservations(e.id, d.date_ymd)}
                                                        >
                                                            <b>
                                                                {d.date}
                                                            </b>
                                                            {d.day}
                                                            <Tooltip title={trans('random.viewOnMap')}>
                                                                <img src={mapImage} />
                                                            </Tooltip>
                                                        </a>
                                                    }
                                                </th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {props.data.periods.map(p =>
                                            <tr key={'p-' + p.id}>
                                                <td>
                                                    <span>
                                                        {p.period}
                                                    </span>
                                                </td>
                                                {Object.entries(props.data.dates).map((date, i) =>
                                                    <td key={'tdd-' + date[0]}>
                                                        <span>
                                                            <DndProvider manager={manager} key={1}>
                                                                {getReservations(e.id, date[0], p.id).map((r, i) =>
                                                                    renderCard(r, i, e.id, date[0], p.id)
                                                                )}
                                                            </DndProvider>

                                                            {!hasFreeDay(e, date[1].date_ymd)
                                                                ?
                                                                <button className="button-add button-extra-small" onClick={() => handleAddReservation(e.id, date[0], p.id)}>
                                                                    {trans('buttons.add')}
                                                                </button>
                                                                :
                                                                ''
                                                            }
                                                        </span>
                                                    </td>
                                                )}
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                    </React.Fragment>
                )

            }

            <UpcomingReservations
                ref={upcomingReservationsRef}
            />

            <EmployeeInfoPopup
                employee={popupEmployee}
                pos={popupPos}
                visible={popupVisible}
                onClose={handleCloseEmployeeInfo}
            />

        </>
    )
}

export default Table